<template>
  <article :class="type">
    <n-icon :icon="icon" size="m" />
    <div class="content">
      <h6 v-if="title">{{ title }}</h6>
      <div v-else>{{ content }}</div>
      <p>
        <slot>{{ title ? content : '' }}</slot>
      </p>
    </div>
    <slot name="actions" />
  </article>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'n-banner' })
export default class NBanner extends Vue {
  @Prop({ default: '' }) title!: string
  @Prop({ default: '' }) content!: string
  @Prop({ default: 'information-circle' }) icon!: string
  @Prop({ default: 'info', validator: (value: string) => ['info', 'warning', 'success', 'neutral'].includes(value) })
  type!: 'info' | 'warning' | 'success' | 'neutral'
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

article {
  padding: $notch-space-4x;
  border: 0 solid transparent;
  border-radius: $notch-space-2x;
  display: flex;
  justify-content: space-between;
  gap: $notch-space-3x;

  .content {
    flex: 1;
  }

  &.info {
    background-color: $notch-color-semantic-accent-100;
  }

  &.warning {
    background-color: $notch-color-semantic-alert-100;
  }

  &.success {
    background-color: $notch-color-semantic-success-100;
  }

  &.neutral {
    background-color: $notch-color-neutral-sand-50;
  }
}

span {
  display: flex;
  justify-content: center;
  align-items: center;
}

h6 {
  @include notch-text-label-strong-M;
  margin-bottom: $notch-space-1x;
}

p {
  @include notch-text-label-light-XS;
  color: $notch-color-neutral-sand-600;
}
</style>
